<template>
  <div>
    <validation-observer
      ref="rubyPrice"
    > 
      <validation-provider
        name="Ruby price"
        v-slot="validationContext"
        :rules="{ required: true, min_value: 0}"
      >
        <b-form-group label="Ruby price" label-for="h-number">
          <b-form-input
            v-model="config_data.value"
            :state="getValidationState(validationContext)"
            type="number"
            aria-describedby="input-ruby-price-feedback"
          />
          <b-form-invalid-feedback id="input-ruby-price-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>
      <div style="text-align: right">
        <b-button @click="updateRubyPrice" variant="success">Update</b-button>
      </div>
    </validation-observer>
    
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate/dist/vee-validate.full'
import service from '../../service'
export default {
  components:{
    ValidationProvider,
    ValidationObserver
  },
  props:{
    config_data: {type: Object, default: null}
  },
  methods:{
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    async updateRubyPrice(){
      let validation = await this.$refs.rubyPrice.validate()
      if (!validation){
        this.$store.dispatch("pushErrorNotify", {
          text: "Ruby price validate error",
        });
      }
      else{
        let data = this.config_data;
        data.value = parseFloat(data.value);
        await service.update(
          JSON.stringify(data)
        );
      }
    },
  }
}
</script>